import './_common.js';
import '../css/contact.scss';
import { setupContactForm } from './ui-part/contact-form.js'

window.addEventListener('DOMContentLoaded', () => {
    setupContactForm();
});
